import { getGlobalSearchConfig } from '@/components/global-search/GlobalSearchConfig';
import { getAllNavigationItems } from '@/components/global-search/utils';
import { useSession } from '@/components/session/useSession';

export const useSearchNavigationItems = () => {
  const {
    isAdmin,
    org: { orgSector, isEconomicUnitsToggled },
    featureFlags: { REPORTING_MENU_OPTION_ENABLED, ACTION_PLANNING_MENU_OPTION_ENABLED, CBI_ENABLED },
  } = useSession();

  const globalSearchConfig = getGlobalSearchConfig(
    isEconomicUnitsToggled,
    REPORTING_MENU_OPTION_ENABLED,
    ACTION_PLANNING_MENU_OPTION_ENABLED,
    isAdmin,
    CBI_ENABLED,
    orgSector,
  );

  return getAllNavigationItems(globalSearchConfig);
};
